<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">

            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{ 'businessIntelligence.rankingCompras.dealers' }}
                </div>

                <span
                  class="btn btn-outline-info btn-sm"
                  *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;"
                  (click)="removerDealer(dealer)"
                >
                  {{ dealer.nome }}
                  <i class="fa fa-times" aria-hidden="true"></i>
                </span>

                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <hr>

            <div class="row ptb50">
              <div class="col col-3">
                <div translate class="filtro" style="margin: 0px 10px 0px 0px;">
                  {{ 'businessIntelligence.rankingCompras.dataInicial' }}
                </div>
                <p-calendar
                  [(ngModel)]="dataInicial"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  [maxDate]="maxDate"
                  (onClearClick)="limpaDataInicial()"
                  placeholder="{{ 'businessIntelligence.rankingCompras.dataInicialPlaceHolder' | translate }}"
                  showButtonBar="true"
                ></p-calendar>
              </div>

              <div class="col col-3">
                <div translate class="filtro" style="margin: 0px 10px 0px 0px;">
                  {{ 'businessIntelligence.rankingCompras.dataFinal' }}
                </div>
                <p-calendar
                  [(ngModel)]="dataFinal"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  [maxDate]="maxDate"
                  (onClearClick)="limpaDataFinal()"
                  placeholder="{{ 'businessIntelligence.rankingCompras.dataFinalPlaceHolder' | translate }}"
                  showButtonBar="true"
                ></p-calendar>
              </div>

              <!-- <div class="col col-2">
                <div translate class="filtro" style="margin: 0px 10px 0px 0px;">
                  {{ 'businessIntelligence.rankingCompras.limite' }}
                </div>
                <input
                  pInputText
                  type="number"
                  class="form-control"
                  min="1"
                  [(ngModel)]="limite"
                />
              </div> -->

              <div class="col col-4">
                <button
                  translate
                  type="button"
                  class="btn btn-primary mt-3 mr-2"
                  (click)="filtroAPI()"
                >
                  {{ 'businessIntelligence.rankingCompras.filtrar' }}
                  <i class="fas fa-search"></i>
                </button>

                <button
                  pButton
                  class="p-button-outlined p-button-secondary p-button-sm float-right mt-3"
                  type="button"
                  (click)="exportExcel()"
                  [disabled]="!clientesDados?.length"
                >
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>

            <hr>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <div
      translate
      *ngIf="clientesDados?.length <= 0 && !cargaTela"
      class="sem-registros text-muted mt-2"
    >
      {{ 'businessIntelligence.rankingCompras.nenhumRegistroExibir' }}
    </div>

    <div class="ranking-grid" *ngIf="clientesDados?.length > 0">
    <p-table
      #dt
      [value]="clientesDados"
      dataKey="posicao"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm"
      [columns]="cols"
      [loading]="loading"
      [autoLayout]="true"
      [globalFilterFields]="['posicao','documento','nome','qtd','total','pct']"
      id="excel-table"
    >
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{ 'businessIntelligence.rankingCompras.filtroGeral' | translate }}"
            />
          </span>

          <p-multiSelect
            *ngIf="translate.currentLang == 'br'"
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="headerBr"
            selectedItemsLabel="{{ 'businessIntelligence.rankingCompras.colunasSelecionadas' | translate }}"
            [style]="{ minWidth: '200px' }"
            placeholder="{{ 'businessIntelligence.rankingCompras.colunasSelecionadasPlaceHolder' | translate }}"
          ></p-multiSelect>

          <p-multiSelect
            *ngIf="translate.currentLang == 'gb'"
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="headerGb"
            selectedItemsLabel="{{ 'businessIntelligence.rankingCompras.colunasSelecionadas' | translate }}"
            [style]="{ minWidth: '200px' }"
            placeholder="{{ 'businessIntelligence.rankingCompras.colunasSelecionadasPlaceHolder' | translate }}"
          ></p-multiSelect>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of selectedColumns">
            <th
              class="text-center"
              [translate]="getTranslate(col.header)"
              [pSortableColumn]="col.field"
              style="background-color:black;color:white;"
            >
              {{ translate.currentLang == 'br' ? col.headerBr : col.headerGb }}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="sort" />
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr [class.row-selected]="clienteSelecionado?.posicao === row.posicao">
          <ng-container *ngFor="let col of selectedColumns">
            <td *ngIf="col.field != 'qtd'" class="text-center">
              <ng-container [ngSwitch]="col.field">
                <span *ngSwitchCase="'nome'">{{ labelCliente(row) }}</span>
                <span *ngSwitchCase="'documento'">{{ formatarDocumento(row[col.field]) }}</span>
                <ng-container *ngSwitchDefault [ngSwitch]="col.type">
                  <span *ngSwitchCase="'currency'">{{ row[col.field] | number:'1.2-2':'pt-BR' }}</span>
                  <span *ngSwitchCase="'percent'">{{ row[col.field] | number:'1.2-2':'pt-BR' }}%</span>
                  <span *ngSwitchDefault>{{ row[col.field] }}</span>
                </ng-container>
              </ng-container>
            </td>
            <td *ngIf="col.field == 'qtd'" class="text-center">
              <a *ngIf="row.qtd" class="link" (click)="detalharCliente(row)">
                {{ row.qtd }}
              </a>
              <span *ngIf="!row.qtd">{{ row.qtd }}</span>
            </td>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr class="footer-total">
          <ng-container *ngFor="let col of selectedColumns">
            <td class="text-center font-weight-bold">
              <ng-container [ngSwitch]="col.field">
                <span *ngSwitchCase="'posicao'">
                  {{ 'businessIntelligence.rankingCompras.totalGeral' | translate }}
                </span>
                <span *ngSwitchCase="'qtd'">
                  {{ totalQtd }}
                </span>
                <span *ngSwitchCase="'total'">
                  {{ totalValor | number:'1.2-2':'pt-BR' }}
                </span>
                <span *ngSwitchCase="'pct'">
                  {{ totalPct | number:'1.2-2':'pt-BR' }}%
                </span>
                <span *ngSwitchDefault></span>
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
    </div>

    <div *ngIf="clientesDados?.length > 0 && !cargaTela" class="ranking-chart">
      <h5 class="mb-3">{{ 'businessIntelligence.rankingCompras.tituloGrafico' | translate }}</h5>
      <div class="ranking-chart-canvas" [style.height.px]="chartHeight">
        <canvas
          baseChart
          [datasets]="barChartData"
          [labels]="barChartLabels"
          [colors]="barChartColors"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          [chartType]="barChartType"
          (chartClick)="onChartClick($event)"
        ></canvas>
      </div>
    </div>

  </div>
</div>

<p-dialog
  [(visible)]="displayDetalhe"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="fecharDetalhe()"
>
  <ng-template pTemplate="header">
    <span *ngIf="clienteSelecionado">
      {{ 'businessIntelligence.rankingCompras.tituloDetalhe' | translate }}
      — {{ labelCliente(clienteSelecionado) }}
      <ng-container *ngIf="!isSemCliente(clienteSelecionado)">
        ({{ formatarDocumento(clienteSelecionado.documento) }})
      </ng-container>
    </span>
  </ng-template>

  <div *ngIf="loadingDetalhe" class="d-flex justify-content-center my-4">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div
    translate
    *ngIf="!loadingDetalhe && comprasDados?.length <= 0"
    class="sem-registros text-muted mt-2"
  >
    {{ 'businessIntelligence.rankingCompras.nenhumaCompraExibir' }}
  </div>

  <div *ngIf="!loadingDetalhe && comprasDados?.length > 0">
    <div class="d-flex justify-content-end mb-2">
      <button
        pButton
        class="p-button-outlined p-button-secondary p-button-sm"
        type="button"
        (click)="exportExcelDetalhe()"
      >
        <i class="fa fa-download mr-1"></i>Export Excel
      </button>
    </div>

    <p-table
      #dtDetalhe
      [value]="comprasDados"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm"
      [paginator]="comprasDados.length > 10"
      [rows]="10"
      [autoLayout]="true"
      currentPageReportTemplate="{{ 'businessIntelligence.rankingCompras.mostrandoRegistros' | translate }}"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10,20,30,50,100]"
      [globalFilterFields]="['codDealer','dealer','documento','nomeFornecedor','numeroNotaCompra','serie','dataEmissao','totalNota']"
    >
      <ng-template pTemplate="caption">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dtDetalhe.filterGlobal($event.target.value, 'contains')"
            placeholder="{{ 'businessIntelligence.rankingCompras.filtroGeral' | translate }}"
          />
        </span>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th
            *ngFor="let col of colsDetalhe"
            class="text-center"
            [translate]="getTranslate(col.header)"
            [pSortableColumn]="col.field"
            style="background-color:black;color:white;"
          >
            {{ translate.currentLang == 'br' ? col.headerBr : col.headerGb }}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td *ngFor="let col of colsDetalhe" class="text-center">
            <ng-container [ngSwitch]="col.type">
              <span *ngSwitchCase="'currency'">{{ row[col.field] | number:'1.2-2':'pt-BR' }}</span>
              <span *ngSwitchCase="'documento'">{{ formatarDocumento(row[col.field]) }}</span>
              <span *ngSwitchCase="'date'">{{ formatarDataEmissao(row[col.field]) }}</span>
              <span *ngSwitchDefault>{{ row[col.field] != null && row[col.field] !== '' ? row[col.field] : '—' }}</span>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr class="footer-total">
          <td
            *ngFor="let col of colsDetalhe"
            class="text-center font-weight-bold"
          >
            <ng-container [ngSwitch]="col.field">
              <span *ngSwitchCase="'nomeFornecedor'">
                {{ 'businessIntelligence.rankingCompras.totalGeral' | translate }}
              </span>
              <span *ngSwitchCase="'totalNota'">
                {{ totalNotasDetalhe | number:'1.2-2':'pt-BR' }}
              </span>
              <span *ngSwitchDefault></span>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)"
>
</app-filtro-dealers>
